// SearchBar.jsx  –  plain-JS version
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

export default function SearchBar({
  onSearch,
  placeholder = 'Search…',
  fullWidth = true,
}) {
  const [value, setValue] = useState('');

  // debounce 300 ms
  useEffect(() => {
    const id = setTimeout(() => onSearch(value), 300);
    return () => clearTimeout(id);
  }, [value, onSearch]);

  return (
    <TextField
      size="small"
      variant="outlined"
      value={value}
      onChange={e => setValue(e.target.value)}
      placeholder={placeholder}
      fullWidth={fullWidth}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
      sx={{
        backgroundColor: 'background.paper',
        '& .MuiOutlinedInput-root': { borderRadius: 2 },
      }}
    />
  );
}